type GetLanguageNameByCodeOptions = {
  onError?: (error: Error, code?: string) => void;
};

export function getLanguageNameByCode(code?: string, options?: GetLanguageNameByCodeOptions) {
  try {
    if (!code) {
      return undefined;
    }

    const lang = new Intl.DisplayNames(['en'], { type: 'language' });
    return lang.of(code);
  } catch (error) {
    if (options?.onError) {
      options.onError(error as Error, code);
    }
    return undefined;
  }
}
